import { DataService } from '../../../services/data_service';
import { EmissionsfaktorenImport } from './EmissionsfaktorenImport';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { WUploadButton } from '../../../core/elements/WUploadButton';

interface DatenverwaltungKlimagaseArtProps extends React.ClassAttributes<any> {
    data: any;
}

interface DatenverwaltungKlimagaseArtState extends React.ClassAttributes<any> {
    allCheckboxChecked: boolean;
    data: any[];
    dataImport: string;
    selectedTids: any;
}

export class DatenverwaltungKlimagaseArt extends React.Component<DatenverwaltungKlimagaseArtProps, DatenverwaltungKlimagaseArtState> {

    constructor(props: any) {
        super(props);
        this.state = {
            allCheckboxChecked: false,
            data: null,
            dataImport: null,
            selectedTids: {}
        };
        this.isRowSelected = this.isRowSelected.bind(this);
        this.onDataLoaded = this.onDataLoaded.bind(this);
        this.onRowSelect = this.onRowSelect.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private entity: string = IDs.ENT_CO2_FAKTOREN_KLIMAGASE;
    private params: any = { uniques: [{ columns: ['art', 'jahr', 'quelle'], values: { wert: true } }] };

    delData(): void {
        const selectedTids: any = this.state.selectedTids || {};
        const tids: any[] = [];

        Object.keys(selectedTids).forEach((tid: string) => {
            if (selectedTids[tid]) {
                tids.push({ tid: +tid });
            }
        });

        if (window.confirm(`Datensätze [${tids.length}] wirklich löschen?`)) {
            this.dataService.delDataList(
                this.entity, tids,
                () => {
                    this.triggerService.fire('reload', this.entity);
                    this.setState({ selectedTids: {} }, () => alert(`Datensätze [${tids.length}] wurden gelöscht.`));
                },
                IDs.MOD_ETOOL_ADMIN
            );
        }
    }

    isRowSelected(row: any): boolean {
        const selectedTids: any = this.state.selectedTids || {};

        return selectedTids.all && !selectedTids[(row || {}).tid];
    }

    onDataLoaded(dataImport: string): void {
        this.setState({ dataImport });
    }

    onRowSelect(row: any, selected: boolean, selectedTids: any): void {
        this.setState({
            selectedTids: selectedTids || {},
            allCheckboxChecked: (row || {}).tid === 'all' && selected
        });
    }

    render(): JSX.Element {
        return <>
            {!this.state.dataImport &&
                <WFormsTableWrapper
                    entity={this.entity}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit', 'delete']}
                    externalHeaderElements={[this.renderDeleteButton(), this.renderUploadButton()]}
                    customClass='Custom-ETA'
                    formLayout='flowV2'
                    onDataLoaded={(data: any[]) => this.setState({ data })}
                    enableRowCheckbox
                    onRowSelect={this.onRowSelect}
                    isRowSelected={this.isRowSelected}
                    allCheckboxChecked={this.state.allCheckboxChecked}
                    checkedRows={this.state.selectedTids}
                    onDelDone={() => this.setState({ selectedTids: {} }, () => this.triggerService.fire('admin_reload', this.entity))}
                    onSaveDone={() => this.triggerService.fire('admin_reload', this.entity)}
                    defaultSorted={[{ id: 'art', asc: true }, { id: 'jahr', asc: true }]}
                    showColumnsHelp
                />
            }
            {this.state.dataImport && this.renderImport()}
        </>;
    }

    renderDeleteButton(): JSX.Element {
        const label: string = 'Löschen';
        const selectedTids: any = this.state.selectedTids || {};
        const selectedAnzahl: number = Object.keys(selectedTids)
            .reduce((anzahl: number, tid: string) => anzahl + (selectedTids[tid]), 0);
        const disabled: boolean = selectedAnzahl === 0;
        const styleProps: React.CSSProperties = { ...(disabled ? { backgroundColor: 'lightgray', cursor: 'not-allowed' } : {}) };

        return (
            <WActionButton
                tooltip='Datensätze löschen'
                label={label}
                action='delete'
                key='delete'
                insideText={label}
                indicatorFullNumber
                indicatorValue={selectedAnzahl}
                indicatorColor={selectedAnzahl > 0 ? '#0a0' : '#aaa'}
                disabled={selectedAnzahl === 0}
                styleProps={styleProps}
                onAction={() => this.delData()}
            />
        );
    }

    renderImport(): JSX.Element {
        return (
            <EmissionsfaktorenImport
                data={{ ...(this.props.data || {}), [this.entity]: this.state.data || [] }}
                dataImport={this.state.dataImport}
                entity={this.entity}
                onCancel={() => this.setState({ dataImport: undefined })}
                onSaveDone={() => this.setState({ dataImport: undefined }, () => this.triggerService.fire('reload', this.entity))}
                params={this.params}
            />
        );
    }

    renderUploadButton(): JSX.Element {
        return (
            <WUploadButton
                label='Upload Emissionsfaktoren'
                insideText='Upload Emissionsfaktoren'
                tooltip='Emissionsfaktoren hochladen'
                key='upload'
                onDataLoaded={this.onDataLoaded}
            />
        );
    }
}
